import {
  configureStore, ThunkAction, Action, createListenerMiddleware, PayloadAction,
} from '@reduxjs/toolkit';
import quoteReducer, { actions } from '../features/quote/QuoteSlice';
import { addMiddleware, removeMiddleware, updateMiddleware } from './middleware/DrawQueue';

export const store = configureStore({
  reducer: {
    quote: quoteReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(
    removeMiddleware.middleware,
  ).prepend(addMiddleware.middleware)
    .prepend(updateMiddleware.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
